import axiosFlow from '@/services/axios/axiosFlow'
import { isNullOrUndefined } from '@/utils/functions'

export default class TemplateEmailService {
  static async get(ativo, envioEmMassa) {
    const params = new URLSearchParams()

    if (!isNullOrUndefined(ativo)) {
      params.append('Ativo', ativo)
    }
    if (!isNullOrUndefined(envioEmMassa)) {
      params.append('EnvioEmMassa', envioEmMassa)
    }

    return axiosFlow.get(`templates-email?${params}`).then(res => res.data.data)
  }

  static async getById(templateEmailId) {
    return axiosFlow.get(`templates-email/${templateEmailId}`).then(res => res.data.data)
  }

  static async criar(body) {
    return axiosFlow.post('templates-email', body)
  }

  static async atualizar(templateEmailId, body) {
    return axiosFlow.put(`templates-email/${templateEmailId}`, body)
  }

  static async ativarOuInativar(templateEmailId, body) {
    return axiosFlow.put(`templates-email/${templateEmailId}/ativado`, body)
  }
}
